import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => (
  <div className="min-h-screen bg-gray-50 font-sans">
    <nav className="bg-white shadow-sm">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <Link to="/" className="text-xl font-bold text-brand-navy">
            3PL<span className="text-brand-gold">+</span>
          </Link>
          <Link to="/" className="text-sm font-medium text-body hover:text-brand-navy">
            Back to Home
          </Link>
        </div>
      </div>
    </nav>

    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-3xl font-bold text-brand-navy">Terms of Service</h1>
      <p className="mt-2 text-sm text-gray-500">Last updated: March 2026</p>

      <div className="mt-8 prose prose-gray max-w-none space-y-6 text-body">
        <h2 className="text-xl font-semibold text-brand-navy">1. Services</h2>
        <p>
          DataVisual Marketing Inc. ("we", "us", "our") provides third-party logistics services including warehousing, inventory management, receiving, shipping, kitting, and related fulfillment services through our 3PL+ platform. By using our services or accessing the customer portal, you agree to these terms.
        </p>

        <h2 className="text-xl font-semibold text-brand-navy">2. Account Responsibilities</h2>
        <p>
          You are responsible for maintaining the security of your account credentials and for all activity that occurs under your account. You agree to:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Provide accurate and complete information when setting up your account.</li>
          <li>Keep your login credentials confidential and not share them with unauthorized individuals.</li>
          <li>Notify us promptly if you become aware of any unauthorized use of your account.</li>
          <li>Ensure that any sub-users you invite to your account are authorized to act on behalf of your organization.</li>
        </ul>

        <h2 className="text-xl font-semibold text-brand-navy">3. Inventory and Goods</h2>
        <p>
          By storing inventory with us, you represent that:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>You are the rightful owner of the goods or are authorized to store them on behalf of the owner.</li>
          <li>The goods do not contain any prohibited, hazardous, illegal, or restricted materials.</li>
          <li>You will provide accurate descriptions, quantities, and any relevant product information.</li>
        </ul>

        <h2 className="text-xl font-semibold text-brand-navy">4. Billing and Payment</h2>
        <p>
          Fees for our services are agreed upon during onboarding and documented in your service agreement. Invoices are generated based on completed services and are accessible through the customer portal. Payment terms are as specified in your service agreement.
        </p>

        <h2 className="text-xl font-semibold text-brand-navy">5. Liability</h2>
        <p>
          While we take every reasonable precaution to protect your inventory, our liability for loss or damage to stored goods is limited to the terms outlined in your service agreement. We maintain appropriate insurance coverage for goods in our care.
        </p>

        <h2 className="text-xl font-semibold text-brand-navy">6. Data and Privacy</h2>
        <p>
          Your use of the 3PL+ platform is also governed by our <Link to="/privacy" className="text-brand-gold hover:underline">Privacy Policy</Link>, which describes how we collect, use, and protect your information.
        </p>

        <h2 className="text-xl font-semibold text-brand-navy">7. Acceptable Use</h2>
        <p>
          When using the customer portal, you agree not to:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Attempt to access data belonging to other customers.</li>
          <li>Use the platform for any unlawful purpose.</li>
          <li>Attempt to interfere with the operation or security of the platform.</li>
          <li>Upload malicious files or content.</li>
        </ul>

        <h2 className="text-xl font-semibold text-brand-navy">8. Termination</h2>
        <p>
          Either party may terminate the service relationship with reasonable written notice as specified in your service agreement. Upon termination, you are responsible for arranging the removal of your inventory from our facility within the agreed-upon timeframe.
        </p>

        <h2 className="text-xl font-semibold text-brand-navy">9. Changes to These Terms</h2>
        <p>
          We may update these terms from time to time. Material changes will be communicated to active customers. Continued use of our services after changes take effect constitutes acceptance of the updated terms.
        </p>

        <h2 className="text-xl font-semibold text-brand-navy">10. Contact</h2>
        <p>
          If you have questions about these terms, please <Link to="/#contact" className="text-brand-gold hover:underline">contact us</Link>.
        </p>
      </div>
    </div>
  </div>
);

export default TermsOfService;
